const INVALID_FILE_NAME_CHARACTERS_REGEX = /[<>:"/\\|?*]/g;

export function triggerDownload(url: string, fileName?: string, openInNewTab = false) {
  const workerLink = document.createElement('a');
  workerLink.style.display = 'none';

  workerLink.setAttribute('href', url);

  if (openInNewTab) {
    workerLink.setAttribute('target', '_blank');
    workerLink.setAttribute('rel', 'noopener noreferrer');
  }

  if (fileName) {
    workerLink.setAttribute('download', fileName);
  }

  document.body.appendChild(workerLink);
  workerLink.click();
  document.body.removeChild(workerLink);
}

export function downloadTextFile(fileName: string, text: string, type = 'text/plain') {
  const url = window.URL.createObjectURL(new Blob([text], { type }));
  triggerDownload(url, fileName);
  window.URL.revokeObjectURL(url);
}

export function sanitizeFileNamePart(value: string): string {
  return value.trim().replace(INVALID_FILE_NAME_CHARACTERS_REGEX, '-');
}
